import React from "react";
import { useTranslation } from "react-i18next";
import { usePlan } from "../context/PlanContext";

const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    return Number.isNaN(date.getTime())
        ? isoDate
        : date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

// On the product list (/gift): the active plan and what it includes, from
// PlanContext (limits from Plan Management). plans.js lands here with
// ?plan_update=success after a payment, which heads it "<plan> plan activated".
const ActivePlanSummary = ({ productCount }) => {
    const { t } = useTranslation();
    const { planInfo, hasActivePlan } = usePlan();

    if (!hasActivePlan || !planInfo) return null;

    const limits = planInfo.limits || {};
    const justActivated = new URLSearchParams(window.location.search).get("plan_update") === "success";
    const amount = (value) => (value === -1 ? t("active_plan.unlimited") : value);
    const features = [
        [t("active_plan.products"), limits.maxProducts != null ? `${productCount} / ${amount(limits.maxProducts)}` : null],
        [t("active_plan.domains"), limits.maxDomains != null ? amount(limits.maxDomains) : null],
        [t("active_plan.analytics"), limits.analytics || null],
        [t("active_plan.discount_codes"), typeof limits.discountCodes === "boolean"
            ? t(limits.discountCodes ? "active_plan.included" : "active_plan.not_included") : null],
        [t("active_plan.support"), limits.support || null],
    ].filter(([, value]) => value != null);

    return (
        <section className="active-plan-summary" aria-label={t("active_plan.title", { name: planInfo.plan_name })} style={{
            background: justActivated ? "#f0f9f4" : "#fff",
            border: `1px solid ${justActivated ? "#1E5B3A" : "#e0e0e0"}`,
            borderRadius: "10px",
            padding: "14px 18px",
            margin: "0 0 16px",
        }}>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "baseline", gap: "6px 14px", marginBottom: "8px" }}>
                <strong style={{ color: "#1E5B3A", fontSize: "1.1em" }}>
                    {justActivated
                        ? t("active_plan.activated", { name: planInfo.plan_name })
                        : t("active_plan.title", { name: planInfo.plan_name })}
                </strong>
                {planInfo.expires_on && (
                    <span style={{ color: "#666" }}>{t("active_plan.valid_until", { date: formatDate(planInfo.expires_on) })}</span>
                )}
            </div>
            <ul style={{ display: "flex", flexWrap: "wrap", gap: "6px 24px", listStyle: "none", margin: 0, padding: 0 }}>
                {features.map(([label, value]) => (
                    <li key={label}>
                        <span style={{ color: "#666" }}>{label}: </span>
                        <strong style={{ textTransform: "capitalize" }}>{value}</strong>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default ActivePlanSummary;
